import { Drawer, Skeleton } from "antd";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import { getPmaBanksData } from "containers/services/services";
import { useAppContext } from "utils/context";
import Header from "components/header";
import BanksList from "./components/list";

const BankInfoDrawer = ({ open, onClose, onSetBanksData }) => {
  const { t } = useTranslation();
  const { instance } = useAppContext();

  const [banks, setBanks] = useState(null);
  const [loading, setLoading] = useState(false);

  const getFundBanks = async () => {
    setLoading(true);
    const response = await getPmaBanksData(instance);
    if (response?.bank_accounts) {
      setBanks(response?.bank_accounts);
      if (onSetBanksData) onSetBanksData(response?.bank_accounts);
    }
    setLoading(false);
  };

  useEffect(() => {
    getFundBanks();
  }, []);

  const renderNotFound = () => {
    return (
      <span className="text-gray-4 mx-auto body-14px-medium">
        {t("pma-inventory-increase.banks-not-found")}
      </span>
    );
  };

  const renderBanks = () => {
    return banks?.length
      ? banks?.map((item) => <BanksList data={item} />)
      : renderNotFound();
  };

  return (
    <Drawer
      title={t("banks-info-title")}
      placement={window.innerWidth < 768 ? "bottom" : "left"}
      open={open}
      key="bottom"
      onClose={onClose}
      className={window.innerWidth < 768 && "max-h-drawer"}
    >
      <div>
        <Header title={`${t("asset-page.banks-accounts")}:`} />
        {renderBanks()}
        <Skeleton loading={loading} />
      </div>
    </Drawer>
  );
};
export default BankInfoDrawer;
